module.exports = __webpack_public_path__ + "static/media/checked-1.7ab81808.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/checked-1.svg
// module id = 680
// module chunks = 0